import Grid from "@mui/material/Grid";
import {
  AutocompleteInput,
  maxLength,
  minLength,
  minValue,
  number,
  NumberInput,
  ReferenceInput,
  required,
} from "react-admin";
import {
  OptionRenderer,
  orFilterToQuery,
  orInputText,
  orMatchSuggestion,
} from "../../common/OptionRenderer";

const validateProduct = [required(), minLength(36), maxLength(36)];
const validateAmount = [required(), number(), minValue(1)];

export default function Inputs({ getSource }) {
  return (
    <Grid container spacing={2} sx={{ mt: 0 }}>
      <Grid item xs={12}>
        <ReferenceInput source={getSource("product_id")} reference="products">
          <AutocompleteInput
            label="Product"
            variant="outlined"
            isRequired
            fullWidth
            validate={validateProduct}
            optionText={<OptionRenderer />}
            inputText={orInputText}
            matchSuggestion={orMatchSuggestion}
            filterToQuery={orFilterToQuery}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12}>
        <NumberInput
          source={getSource("amount")}
          label="Amount"
          variant="outlined"
          fullWidth
          isRequired
          validate={validateAmount}
        />
      </Grid>
    </Grid>
  );
}
